@if (model.id) {
    <app-contact-card-list-widget
        [addressId]="model.id"
        #contactCardWidget
        [addressModelSig]="model"
    ></app-contact-card-list-widget>
}
